import styled, { css } from 'styled-components';

export const ItemSlot = styled.div<{ $isSelected?: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  overflow: visible;
  /* Selected row sits below neighbors so the pulse passes under their avatars. */
  z-index: ${({ $isSelected }) => ($isSelected ? 0 : 1)};
`;

export const AvatarStack = styled.div<{ $dimmed: boolean }>`
  position: relative;
  z-index: 1;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $dimmed }) =>
    $dimmed &&
    css`
      filter: grayscale(0.42) brightness(0.9);
      opacity: 0.94;
    `}

  img {
    border-radius: 50%;
  }
`;

export const StateBadge = styled.span<{
  $variant: 'blocked' | 'subscriptionSlotInactive' | 'subscriptionInactive';
}>`
  position: absolute;
  right: 5px;
  bottom: 5px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  pointer-events: none;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(15, 24, 20, 0.28);
  z-index: 2;

  ${({ $variant }) =>
    $variant === 'blocked'
      ? css`
          background: linear-gradient(160deg, #d46272 0%, #b8384c 100%);
        `
      : css`
          background: linear-gradient(160deg, #c4c8c6 0%, #858b88 100%);
          box-shadow: 0 1px 3px rgba(15, 36, 31, 0.14);
        `}

  svg {
    display: block;
  }
`;
